module.exports = __webpack_public_path__ + "d61d00287beb4c9e28ec3ca0e7b6c9ca.jpg";